import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import Divider from 'material-ui/Divider';
import { ListItemIcon, ListItemText } from 'material-ui/List';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupIcon from '@material-ui/icons/Group';
import HomeIcon from '@material-ui/icons/Home';
import HelpIcon from '@material-ui/icons/Help';
import FeedbackIcon from '@material-ui/icons/Feedback';
import LinkIcon from '@material-ui/icons/Link';
import InputIcon from '@material-ui/icons/Input';
import FileTree from '@material-ui/icons/AccountTree';
import Console from '../../lib/debug';
import CONF from '../../api/config';
import * as Authorization from '../../lib/authorization';
import * as AppState from '../../state/reducer/app/appState';
import { FEATURES } from '../../v5/features/components/constants';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../lib/segment/SegmentService';

class LoggedInUserAvatar extends Component {
    state = {
        anchorEl: null
    };
    handleMenu = event => {
        SegmentService.track(SEGMENT_EVENTS.ClickCTA.key, {
            sources: 'Web app',
            ctaLocation: 'Main Nav',
            ctaText: 'Avatar icon'
        });
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (buttonIdentifier, orgId) => {
        this.setState({ anchorEl: null });
        const { features } = this.props;

        switch (buttonIdentifier) {
            case 'billing':
                if (features[FEATURES.COACH_PRICING]) {
                    return window.location.replace(
                        Authorization.navigateToSubscriptionPlans.path
                    );
                }
                return window.location.replace(
                    Authorization.navigateToLegacyBilling.path
                );
            case 'settings':
                return window.location.replace(
                    Authorization.navigateToSettings.path
                );
            case 'organizations':
                return Authorization.navigateToOrgSettings(orgId);
            case 'coaches':
                return window.location.replace(
                    Authorization.navigateToAssistantCoaches.path
                );
            case 'integrations':
                return window.location.replace(
                    Authorization.navigateToIntegrations.path
                );
            case 'submitFeedback':
                return window.open(Authorization.navigateToSubmitFeedback.path);
            case 'marketingLinks':
                return window.location.replace(
                    Authorization.navigateToAttributions.path
                );
            case 'support':
                return window.open(Authorization.navigateToSupport.path);
            case 'logout':
                return AppState.logout();
        }
    };

    render() {
        Console.render('LoggedInUserAvatar');

        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        let hasUser = null;
        const { loggedInUser, headCoach } = this.props;

        if (loggedInUser) {
            let userAvatar = loggedInUser.profileImg;
            const isMarketplaceEnabled = headCoach.isMarketplaceEnabled;
            hasUser = (
                <div>
                    <IconButton
                        aria-owns={open ? 'menu-appbar' : null}
                        aria-haspopup="true"
                        onClick={this.handleMenu}
                        color="inherit"
                        classes={{ root: 'avatar-icon' }}
                    >
                        <div className="circle-avatar">
                            <img alt="" src={userAvatar} />
                            <i className="mdi mdi-chevron-down" />
                        </div>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        open={open}
                        onClose={this.handleClose.bind(this)}
                    >
                        {headCoach ? (
                            <Fragment>
                                <MenuItem
                                    onClick={this.handleClose.bind(
                                        this,
                                        'billing',
                                        headCoach.orgId
                                    )}
                                >
                                    <ListItemIcon>
                                        <CreditCardIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        inset
                                        secondary="Billing Info"
                                    />
                                </MenuItem>
                                <MenuItem
                                    onClick={this.handleClose.bind(
                                        this,
                                        'settings',
                                        headCoach.orgId
                                    )}
                                >
                                    <ListItemIcon>
                                        <SettingsIcon />
                                    </ListItemIcon>
                                    <ListItemText secondary="Settings" />
                                </MenuItem>
                                <MenuItem
                                    onClick={this.handleClose.bind(
                                        this,
                                        'organizations',
                                        headCoach.orgId
                                    )}
                                >
                                    <ListItemIcon>
                                        <HomeIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        inset
                                        secondary="My Organizations"
                                    />
                                </MenuItem>
                                {headCoach &&
                                    !loggedInUser.isBasic && (
                                        <MenuItem
                                            onClick={this.handleClose.bind(
                                                this,
                                                'coaches',
                                                headCoach.orgId
                                            )}
                                        >
                                            <ListItemIcon>
                                                <GroupIcon />
                                            </ListItemIcon>
                                            <ListItemText
                                                inset
                                                secondary="My Assistant Coaches"
                                            />
                                        </MenuItem>
                                    )}
                                {headCoach &&
                                    isMarketplaceEnabled &&
                                    !loggedInUser.isBasic && (
                                        <MenuItem
                                            onClick={this.handleClose.bind(
                                                this,
                                                'integrations',
                                                headCoach.orgId
                                            )}
                                        >
                                            <ListItemIcon>
                                                <FileTree />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                secondary="Zapier Integrations"
                                            />
                                        </MenuItem>
                                    )}
                                {headCoach &&
                                    !loggedInUser.isBasic && (
                                        <MenuItem
                                            onClick={this.handleClose.bind(
                                                this,
                                                'submitFeedback',
                                                headCoach.orgId
                                            )}
                                        >
                                            <ListItemIcon>
                                                <FeedbackIcon />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                secondary="Submit Feedback"
                                            />
                                        </MenuItem>
                                    )}
                                {headCoach &&
                                    isMarketplaceEnabled &&
                                    !loggedInUser.isBasic && (
                                        <MenuItem
                                            onClick={this.handleClose.bind(
                                                this,
                                                'marketingLinks',
                                                headCoach.orgId
                                            )}
                                        >
                                            <ListItemIcon>
                                                <LinkIcon />
                                            </ListItemIcon>

                                            <ListItemText
                                                inset
                                                secondary="Marketing Links"
                                            />
                                        </MenuItem>
                                    )}
                            </Fragment>
                        ) : null}
                        <MenuItem
                            onClick={this.handleClose.bind(
                                this,
                                'support',
                                headCoach.orgId
                            )}
                        >
                            <ListItemIcon>
                                <HelpIcon />
                            </ListItemIcon>
                            <ListItemText inset secondary="Support" />
                        </MenuItem>
                        <Divider />
                        <MenuItem
                            onClick={this.handleClose.bind(
                                this,
                                'logout',
                                headCoach.orgId
                            )}
                        >
                            <ListItemIcon>
                                <InputIcon />
                            </ListItemIcon>
                            <ListItemText inset secondary="Logout" />
                        </MenuItem>
                    </Menu>
                </div>
            );
        }

        return hasUser;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        loggedInUser: state.app.loggedInUser,
        headCoach: state.app.headCoach,
        features: state.features
    };
};

export default connect(mapStateToProps)(LoggedInUserAvatar);
